import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import i18n from "i18next";

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    backend: { loadPath: `/locale/{{lng}}.json?v=${process.env.REACT_APP_VERSION}` },
    fallbackLng: "en",
    lng: "en",
    load: "languageOnly",
    interpolation: { escapeValue: false },
  });

export default i18n;
